module.exports = __webpack_public_path__ + "img/naw-wow-logo.af3407ce.jpg";